import { debounce } from "throttle-debounce"

export const debouncedTrackPage = debounce(1000, async (name, data) => {
  const { category, ...properties } = data || {}

  try {
    const location = {
      origin: window.location.origin,
      pathname: window.location.pathname,
      search: window.location.search,
    }

    const analyticsData = {
      name,
      category,
      properties: {
        ...location,
        ...properties,
      },
    }

    const response = await fetch("/analytics/page", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(analyticsData),
    })
    if (!response || !response.ok) {
      console.error("Error tracking page", response)
    }
  } catch (e) {
    console.error("Error tracking page", e)
  }
})
